import { Step, StepLabel, Stepper as MuiStepper } from '@mui/material';
import { CreateCourseSteps } from 'src/helpers';

export const Stepper = ({ activeStep }) => (
  <MuiStepper alternativeLabel activeStep={activeStep}>
    {CreateCourseSteps.map((step, index) => {
      const { label, value } = step;
      return (
        <Step key={index} active={value === activeStep}>
          <StepLabel>{label}</StepLabel>
        </Step>
      );
    })}
  </MuiStepper>
);
